module.exports = __webpack_public_path__ + "img/item8.2005d1ff.png";